export namespace S3Service {
  export function upload(
    file: File,
    presignedUrl: string,
    onProgress?: (progress: number) => void,
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest()
      xhr.open('PUT', presignedUrl)

      xhr.upload.onprogress = (event) => {
        if (!event.lengthComputable) return
        onProgress?.(Math.round((event.loaded / event.total) * 100))
      }

      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve()
        } else {
          reject(new Error(`Upload failed with status ${xhr.status}`))
        }
      }

      xhr.onerror = () => reject(new Error('Network error during upload'))
      xhr.setRequestHeader('Content-Type', file.type || 'audio/mpeg')
      xhr.send(file)
    })
  }
}
